import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { tracking } from '../../utils/tracking';
import Header from '../../components/Header';

import { clearEnvironment, setEnvironment } from '../../actions/environment';
import { setOption } from '../../actions/options';

class MainWrap extends Component {
  constructor (props) {
    super(props);
    const { dispatch, match } = props;
    const { environment } = match.params;
    this.boundActionCreators = bindActionCreators({
      clearEnvironment,
      setEnvironment,
      setOption,
    }, dispatch);

    // if casemanagers URL, set source to Staff
    if (this.props.location.pathname.includes('casemanagers')) {
      window.sessionStorage.setItem('source', 'STAFF');
      dispatch(setOption('STAFF'));
    }
    // for new URLs coming from H2A to the patient enroll page
    if (this.props.location.pathname.includes('patient/enroll/eligibility')) {
      dispatch(setOption('PATIENT'));
    }

    // set temporary option when coming from H2A URL with only the treatment
    if (this.props.location.pathname === `/${environment}`) {
      dispatch(setOption('STAFF'));
    }

    props.dispatch(setEnvironment(environment));
    if (!window.sessionStorage.getItem('source')) {
      props.history.push('/');
    }
  }

  componentDidMount () {
    tracking(this.mainWrap); // needed for initial load
  }

  componentDidUpdate (prevProps) {
    if (this.props.match.params.environment === prevProps.match.params.environment) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (this.props.match.params.environment !== prevProps.match.params.environment) {
      this.props.dispatch(setEnvironment(this.props.match.params.environment));
    }
    tracking(this.mainWrap); // needed for re-renders
  }

  render () {
    const { pathname } = this.props.location;
    return (
      <div ref={ section => { this.mainWrap = section; } } className="main-wrap">

        <div className="mobile-header-callout">
          <p><strong className="poppins-bold">We’re here to help.</strong> Call <a href="tel:1-844-817-6468">1-844-817-6468</a>, Option 2, Monday-Friday, 8AM-8PM ET</p>
        </div>

        <Header
          environment={ this.props.match.params.environment }
          onClick={ () => this.props.dispatch(clearEnvironment()) }
          isHome={
            pathname === '/' ||
            pathname === '/alunbrig' ||
            pathname === '/fruzaqla' ||
            pathname === '/iclusig' ||
            pathname === '/mimrylo' ||
            pathname === '/ninlaro'
          }
        />
        { this.props.children}
      </div>
    );
  }
}

export default withRouter(connect()(MainWrap));
